// src/pages/dashboard/section-productions/SectionProductions.jsx
import React from "react";
import { Paper, Stack, Typography, Box } from "@mui/material";
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import ProductionSummary from "../../prodactions/production-summary/ProductionSummary";

function SectionProductions({ paperShadow }) {
    return (
        <Paper
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                boxShadow: paperShadow,
            }}
        >
                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
                    <FactoryOutlinedIcon sx={{ fontSize: 32, color:"#673AB7" }} />
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            Productions
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Deskripsi
                        </Typography>
                    </Box>
                </Stack>
                <Typography variant="body1" color="text.primary">
                    <ProductionSummary/>
                </Typography>
        </Paper>
    );
}

export default SectionProductions;